import {ProjectsConstants as projectConstants} from "./constants/projectConstants";
export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned',
    },
    {
        name: '__slot:wordstat_word',
        sortField: 'word',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: false,
        useInFilter: true,
    },
    {
        name: 'type',
        sortField: 'type',
        type: 'arr',
        callback: 'string',
        defaultSearch: false,
        useInFilter: true,
        items: [
            {value: projectConstants.ASSOCIATIONS_WORD, label:"Похожие"},
            {value: projectConstants.ADDITIONS_WORD, label:"Хвосты"},
            {value: projectConstants.INITIAL_WORD, label:"Исходная фраза"},
        ],
    },
    {
        name: 'initial_word',
        sortField: 'initial_word',
        type: 'string',
        callback: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:wordstat_ws',
        sortField: 'ws',
        type: 'number',
        isDefault: false,
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: '__slot:wordstat_qwsk',
        sortField: 'qwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: false,
        useInFilter: true,
    },
    {
        name: '__slot:wordstat_wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: false,
    },
    {
        name: '__slot:wordstat_swsk',
        sortField: 'swsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: false,
    },
    {
        name: '__slot:wordstat_cpc',
        sortField: 'cpc100',
        type: 'number',
        useInFilter: true,
        defaultSearch: false,
    },
    {
        name: '__slot:wordstat_bdg',
        sortField: 'bdg100',
        type: 'number',
        useInFilter: true,
        defaultSearch: false,
    },
    {
        name: 'updated_at',
        sortField: 'updated_at',
        type: 'unixDateRange',
        defaultSearch: false,
        useInFilter: true,
    },
]
